import React, { useState, useEffect } from 'react';
import { Text, Box, Skeleton, Group } from '@mantine/core';
import { Quote as QuoteIcon } from 'lucide-react';
import { quoteService, Quote } from '../services/quoteService';

export const QuoteOfTheDay: React.FC = () => {
  const [quote, setQuote] = useState<Quote | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadQuote = () => {
      try {
        setLoading(true);
        const fetchedQuote = quoteService.getQuoteOfTheDay();
        setQuote(fetchedQuote);
        setError(false);
      } catch (err) {
        console.error('Error loading quote:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadQuote();
  }, []);

  if (loading) {
    return (
      <Box p="md" style={{ borderTop: '1px solid var(--app-border)' }}>
        <Group gap="xs" mb="xs" align="center">
          <QuoteIcon size={16} color="var(--app-text-muted)" />
          <Text size="xs" c="dimmed" fw={600}>
            Quote of the Day
          </Text>
        </Group>
        <Skeleton height={40} radius="sm" />
        <Skeleton height={16} width="60%" mt="xs" />
      </Box>
    );
  }

  if (error || !quote) {
    return (
      <Box p="md" style={{ borderTop: '1px solid var(--app-border)' }}>
        <Group gap="xs" mb="xs" align="center">
          <QuoteIcon size={16} color="var(--app-text-muted)" />
          <Text size="xs" c="dimmed" fw={600}>
            Quote of the Day
          </Text>
        </Group>
        <Text size="xs" c="dimmed" style={{ fontStyle: 'italic' }}>
          Unable to load quote
        </Text>
      </Box>
    );
  }

  return (
    <Box p="md" style={{ borderTop: '1px solid var(--app-border)' }}>
      <Group gap="xs" mb="xs" align="center">
        <QuoteIcon size={16} color="var(--app-text-muted)" />
        <Text size="xs" c="dimmed" fw={600}>
          Quote of the Day
        </Text>
      </Group>
      
      <Box mb="xs">
        <Text 
          size="xs" 
          style={{ 
            lineHeight: 1.4,
            fontStyle: 'italic',
            color: 'var(--app-text-primary)'
          }}
        >
          "{quote.text}"
        </Text>
      </Box>
      
      <Text size="xs" c="dimmed" style={{ textAlign: 'right', marginBottom: 8 }}>
        — {quote.author}
      </Text>
    </Box>
  );
};